import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_23: DocMigration = {
  maxSchemaVersion: "0.0.23",
  apply(json: any) {
    if (json.planOutputConfig?.staticPlanSheets) {
      const sheets = {};
      for (const sheet of json.planOutputConfig.staticPlanSheets) {
        sheets[uid()] = sheet;
        if (sheet.type === "REMOVE") {
          // drop the "REMOVE" type because sheets with no drawings are skipped
          // and that's enough for us
          sheet.type = "ADD_REPLACE";
          sheet.name = "Sheet removal (migrated)";
          sheet.drawings = [];
        } else if (sheet.type === "ADD_REPLACE") {
          sheet.drawings = sheet.staticDrawings;
          sheet.name = sheet.pageName;
          delete sheet.pageName;
          delete sheet.staticDrawings;
        }
      }
      json.sheets = sheets;
      delete json.planOutputConfig.staticPlanSheets;
    }
    return json;
  },
};

export default migration_0_0_23;
